<template>
  <ContentWrapper>
    <div class="content-heading">
      <div>컨텐츠관리</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#">컨텐츠관리</a>
        </li>
        <li class="breadcrumb-item active">컨텐츠관리</li>
      </ol>
    </div>
    <!-- 검색 -->
    <div class="card card-default">
      <div class="card-body">
        <div class="form-row align-items-center">
          <!-- 기간검색 -->
          <sch-date-rage label="등록일" :data="data"/>
          <!-- 항목 검색 -->
          <sch-text label="검색어" :data="data" @search="search" @reset="reset"/>
        </div>
      </div>
    </div>
    <!-- // 검색-->

    <!-- 목록 -->
    <div v-show="data.params.mode=='list'" class="card card-default">
      <div class="card-header">
        목록
        <div class="card-tool float-right">
          <b-button @click="dataAction.newItem()" class="btn btn-xs btn-outline-info mr-2" variant="outline-primary">
            New
          </b-button>
        </div>
      </div>
      <div class="card-body">
        <table class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <td @click="dataAction.sort(search,'cont_seq')">컨텐츠시퀀스<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'p_cont_seq')">상위컨텐츠시퀀스<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'org_cont_seq')">최상위컨텐츠시퀀스<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'mpp_seq')">맵핑시퀀스<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'cont_type_cd')">컨텐츠유형구분코드<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <!--
<td @click="dataAction.sort(search,'post_type_cd')">컨테츠유형코드<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'title')">제목<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'sub_title')">부제목<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'cont')">내용<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'appr_stat_cd')">승인상태코드<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'ans_stat_cd')">답변상태코드<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'user_type_cds')">노출허용회원유형코드<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'disp_start_dt')">노출시작일<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'disp_end_dt')">노출종료일<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'keywords')">검색 키워드들<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'view_cnt')">조회수<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'opt1')">여유필드1<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'opt2')">여유필드2<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'pay_yn')">유료여부<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'disp_yn')">노출여부<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'allow_rpl_yn')">댓글작성여부<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'del_yn')">삭제여부<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'reg_id')">등록자ID<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'reg_dt')">등록일시<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'upd_id')">수정자ID<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'upd_dt')">수정일시<em class="fa-2s mr-2 fas fa-sort"></em></td>
-->
            <td width="80">Action</td>
          </tr>
          </thead>

          <tbody>
          <tr v-show="data.count==0" class="text-center">
            <td colspan="6">No matching records</td>
          </tr>
          <tr v-for="(item, index) in data.list" :key="index">
            <td>{{ item.contSeq }}</td>
            <td>{{ item.pContSeq }}</td>
            <td>{{ item.orgContSeq }}</td>
            <td>{{ item.mppSeq }}</td>
            <td>{{ item.contTypeCd }}</td>
            <!--
<td>{{item.postTypeCd}}</td>
            <td>{{item.title}}</td>
            <td>{{item.subTitle}}</td>
            <td>{{item.cont}}</td>
            <td>{{item.apprStatCd}}</td>
            <td>{{item.ansStatCd}}</td>
            <td>{{item.userTypeCds}}</td>
            <td>{{item.dispStartDt}}</td>
            <td>{{item.dispEndDt}}</td>
            <td>{{item.keywords}}</td>
            <td>{{item.viewCnt}}</td>
            <td>{{item.opt1}}</td>
            <td>{{item.opt2}}</td>
            <td>{{item.payYn}}</td>
            <td>{{item.dispYn}}</td>
            <td>{{item.allowRplYn}}</td>
            <td>{{item.delYn}}</td>
            <td>{{item.regId}}</td>
            <td>{{item.regDt}}</td>
            <td>{{item.updId}}</td>
            <td>{{item.updDt}}</td>
-->
            <td>
              <div>
                <b-btn variant="outline-info mr-2" class="btn btn-sm btn-secondary" @click.prevent="edit(item)"><em class="fa fa-search"></em></b-btn>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(search)" @prev="dataAction.prev(search)"
                      @first="dataAction.first(search)" @last="dataAction.last(search)" :key="data.params.page"/>
        </div>
      </div>
    </div>
    <!-- // 목록 -->

    <!-- 상세 -->
    <div v-show="data.params.mode=='detail'" class="card card-default">
      <!--<div class="card-header">상세</div>-->
      <div class="card-body">
        <form data-vv-scope="edit">
          <table class="table table-bordered">
            <colgroup>
              <col width="15%" class="bg-lightdark"/>
              <col width="35%"/>
              <col width="15%" class="bg-lightdark"/>
              <col width="35%"/>
            </colgroup>
            <tr>
              <th>컨텐츠시퀀스</th>
              <td>
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.contSeq')}"
                       v-model="data.row.contSeq" placeholder="contSeq" v-validate="''" name="contSeq"
                       style="width: 200px" readonly/>
                <span v-show="errors.has('edit.contSeq')" class="invalid-feedback">{{
                    errors.first('edit.contSeq')
                  }}</span>
              </td>
              <th>상위컨텐츠시퀀스</th>
              <td>
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.pContSeq')}"
                       v-model="data.row.pContSeq" placeholder="pContSeq" v-validate="''" name="pContSeq"
                       style="width: 200px" readonly/>
                <span v-show="errors.has('edit.pContSeq')" class="invalid-feedback">{{
                    errors.first('edit.pContSeq')
                  }}</span>
              </td>
            </tr>
            <tr>
              <th>제목</th>
              <td colspan="4">
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.title')}"
                       v-model="data.row.title" placeholder="title" v-validate="'required'" name="title"/>
                <span v-show="errors.has('edit.title')" class="invalid-feedback">{{ errors.first('edit.title') }}</span>
              </td>
            </tr>
            <tr>
              <th>부제목</th>
              <td colspan="4">
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.subTitle')}"
                       v-model="data.row.subTitle" placeholder="subTitle" v-validate="''" name="subTitle"/>
                <span v-show="errors.has('edit.subTitle')" class="invalid-feedback">{{
                    errors.first('edit.subTitle')
                  }}</span>
              </td>
            </tr>
            <tr>
              <th>내용</th>
              <td colspan="4">
                <textarea type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.cont')}"
                          v-model="data.row.cont" placeholder="cont" v-validate="'required'" name="cont"/>
                <span v-show="errors.has('edit.cont')" class="invalid-feedback">{{ errors.first('edit.cont') }}</span>
              </td>
            </tr>
            <tr>
              <th>첨부파일</th>
              <td colspan="4">

                <!-- todo image upload component-->

                <image-upload :files="files" @upload="upload"/>

              </td>
            </tr>

            <tr>
              <th>최상위컨텐츠시퀀스</th>
              <td>
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.orgContSeq')}"
                       v-model="data.row.orgContSeq" placeholder="orgContSeq" v-validate="''" name="orgContSeq"
                       style="width: 200px"/>
                <span v-show="errors.has('edit.orgContSeq')" class="invalid-feedback">{{
                    errors.first('edit.orgContSeq')
                  }}</span>
              </td>
              <th>맵핑시퀀스</th>
              <td>
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.mppSeq')}"
                       v-model="data.row.mppSeq" placeholder="mppSeq" v-validate="''" name="mppSeq"
                       style="width: 200px"/>
                <span v-show="errors.has('edit.mppSeq')" class="invalid-feedback">{{
                    errors.first('edit.mppSeq')
                  }}</span>
              </td>
            </tr>
            <tr>
              <th>컨텐츠유형구분코드</th>
              <td>
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.contTypeCd')}"
                       v-model="data.row.contTypeCd" placeholder="contTypeCd" v-validate="''" name="contTypeCd"
                       style="width: 200px"/>
                <span v-show="errors.has('edit.contTypeCd')" class="invalid-feedback">{{
                    errors.first('edit.contTypeCd')
                  }}</span>
              </td>
              <th>컨텐츠유형코드</th>
              <td>
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.postTypeCd')}"
                       v-model="data.row.postTypeCd" placeholder="postTypeCd" v-validate="''" name="postTypeCd"
                       style="width: 200px"/>
                <span v-show="errors.has('edit.postTypeCd')" class="invalid-feedback">{{
                    errors.first('edit.postTypeCd')
                  }}</span>
              </td>
            </tr>

            <tr>
              <th>승인상태코드</th>
              <td>
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.apprStatCd')}"
                       v-model="data.row.apprStatCd" placeholder="apprStatCd" v-validate="''" name="apprStatCd"
                       style="width: 200px"/>
                <span v-show="errors.has('edit.apprStatCd')" class="invalid-feedback">{{
                    errors.first('edit.apprStatCd')
                  }}</span>
              </td>
              <th>답변상태코드</th>
              <td>
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.ansStatCd')}"
                       v-model="data.row.ansStatCd" placeholder="ansStatCd" v-validate="''" name="ansStatCd"
                       style="width: 200px"/>
                <span v-show="errors.has('edit.ansStatCd')" class="invalid-feedback">{{
                    errors.first('edit.ansStatCd')
                  }}</span>
              </td>
            </tr>

            <tr>
              <th>노출허용회원유형코드</th>
              <td>
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.userTypeCds')}"
                       v-model="data.row.userTypeCds" placeholder="userTypeCds" v-validate="''" name="userTypeCds"
                       style="width: 200px"/>
                <span v-show="errors.has('edit.userTypeCds')"
                      class="invalid-feedback">{{ errors.first('edit.userTypeCds') }}</span>
              </td>
              <th>조회수</th>
              <td>
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.viewCnt')}"
                       v-model="data.row.viewCnt" placeholder="viewCnt" v-validate="''" name="viewCnt"
                       style="width: 200px"/>
                <span v-show="errors.has('edit.viewCnt')" class="invalid-feedback">{{
                    errors.first('edit.viewCnt')
                  }}</span>
              </td>

            </tr>

            <tr>
              <th>노출시작일</th>
              <td>
                <datepicker
                    v-model="data.row.dispStartDt"
                    format="YYYY-MM-DD"
                    style="width: 250px"/>
              </td>
              <th>노출종료일</th>
              <td>
                <datepicker
                    v-model="data.row.dispEndDt"
                    format="YYYY-MM-DD"
                    style="width: 250px"/>
              </td>

            </tr>
            <tr>
              <th>검색 키워드</th>
              <td colspan="4">
                <input-tag v-model="data.row.listKeywords" class="form-control" placeholder="검색키워드"
                           :key="data.row.contSeq"/>
              </td>
            </tr>

            <tr>
              <th>여유필드1</th>
              <td>
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.opt1')}"
                       v-model="data.row.opt1" placeholder="opt1" v-validate="''" name="opt1" style="width: 200px"/>
                <span v-show="errors.has('edit.opt1')" class="invalid-feedback">{{ errors.first('edit.opt1') }}</span>
              </td>
              <th>여유필드2</th>
              <td>
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.opt2')}"
                       v-model="data.row.opt2" placeholder="opt2" v-validate="''" name="opt2" style="width: 200px"/>
                <span v-show="errors.has('edit.opt2')" class="invalid-feedback">{{ errors.first('edit.opt2') }}</span>
              </td>
            </tr>

            <tr>
              <th>유료여부</th>
              <td>
                <b-input-group>
                  <div>
                    <div class="form-check mb-2">
                      <input class="form-check-input" id='form-check-payYn' v-model="data.row.payYn" true-value="Y"
                             false-value="N" type="checkbox"/>
                      <label class="form-check-label" for='form-check-payYn'>{{
                          data.row.payYn == 'Y' ? '유료' : '무료'
                        }}</label>
                    </div>
                  </div>
                </b-input-group>

              </td>
              <th>노출여부</th>
              <td>
                <b-input-group>
                  <div>
                    <div class="form-check mb-2">
                      <input class="form-check-input" id='form-check-dispYn' v-model="data.row.dispYn" true-value="Y"
                             false-value="N" type="checkbox"/>
                      <label class="form-check-label" for='form-check-dispYn'>{{
                          data.row.dispYn == 'Y' ? '전시' : '숨김'
                        }}</label>
                    </div>
                  </div>
                </b-input-group>
              </td>
            </tr>

            <tr>
              <th>댓글작성여부</th>
              <td>
                <b-input-group>
                  <div>
                    <div class="form-check mb-2">
                      <input class="form-check-input" id='form-check-allowRplYn' v-model="data.row.allowRplYn"
                             true-value="Y"
                             false-value="N" type="checkbox"/>
                      <label class="form-check-label" for='form-check-allowRplYn'>{{
                          data.row.allowRplYn == 'Y' ? '허용' : '불가'
                        }}</label>
                    </div>
                  </div>
                </b-input-group>

              </td>
              <th>삭제여부</th>
              <td>
                <b-input-group>
                  <div>
                    <div class="form-check mb-2">
                      <input class="form-check-input" id='form-check-delYn' v-model="data.row.delYn" true-value="Y"
                             false-value="N" type="checkbox"/>
                      <label class="form-check-label" for='form-check-delYn'>{{
                          data.row.delYn == 'Y' ? '삭제' : '전시'
                        }}</label>
                    </div>
                  </div>
                </b-input-group>

              </td>
            </tr>

            <tr>
              <th>등록자ID</th>
              <td>
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.regId')}"
                       v-model="data.row.regId" placeholder="regId" v-validate="''" name="regId" style="width: 200px"
                       readonly/>
                <span v-show="errors.has('edit.regId')" class="invalid-feedback">{{ errors.first('edit.regId') }}</span>
              </td>
              <th>등록일시</th>
              <td>
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.regDt')}"
                       v-model="data.row.regDt" placeholder="regDt" v-validate="''" name="regDt" style="width: 200px"
                       readonly/>
                <span v-show="errors.has('edit.regDt')" class="invalid-feedback">{{ errors.first('edit.regDt') }}</span>
              </td>
            </tr>

            <tr>
              <th>수정자ID</th>
              <td>
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.updId')}"
                       v-model="data.row.updId" placeholder="updId" v-validate="''" name="updId" style="width: 200px"
                       readonly/>
                <span v-show="errors.has('edit.updId')" class="invalid-feedback">{{ errors.first('edit.updId') }}</span>
              </td>
              <th>수정일시</th>
              <td>
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.updDt')}"
                       v-model="data.row.updDt" placeholder="updDt" v-validate="''" name="updDt" style="width: 200px"
                       readonly/>
                <span v-show="errors.has('edit.updDt')" class="invalid-feedback">{{ errors.first('edit.updDt') }}</span>
              </td>
            </tr>


          </table>
        </form>
      </div>

      <div class="card-footer">
        <div class="card-tool float-right">
          <b-button @click="save()" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">저장</b-button>
          <b-button @click="remove()" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">삭제</b-button>
          <b-button @click="search()" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">목록</b-button>
        </div>
      </div>
    </div>
    <!-- // 상세 -->

    <!-- Modals -->
    <b-modal id="myModal" title="Modal">Hello Modal!</b-modal>
    <b-btn class="btn btn-primary btn-lg mr-1 mb-1" type="button" variant="primary" v-b-modal.myModal> Default modal</b-btn>
  </ContentWrapper>
</template>
<script>
import {reactive, ref, computed, onMounted, onUnmounted, onBeforeMount} from '@vue/composition-api'
import {getCsContList, getCsContItem, saveCsCont, deleteCsCont} from "@/api/cs/CsContApi";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import {dataObject} from "@/utils/Constants";
import SchDateRange from "../../components/Common/SchDateRange";
import SchText from "../../components/Common/SchText";
import Datepicker from 'vuejs-datetimepicker'

import InputTag from 'vue-input-tag'

import ImageUpload from "../../components/Common/ImageUpload";

export default {
  components: {ImageUpload, SchDateRange, SchText, Pagenation, Datepicker, InputTag},
  setup() {
    const schOptions = [{value: 'name', text: '이름'}, {value: 'admin_id', text: 'ID'}]
    const _dataObject = _.cloneDeep(dataObject);
    const data = reactive(_dataObject)
    data.schOptions = schOptions // 검색 type 선택

    const loadData = async () => {
      let result = await getCsContList(data.params);
      data.list = result.data;
      data.count = result.count;
    }
    onMounted(loadData)

    return {
      data,
      file: null,
      files: [],
      loading: false,
      ...methods(),
      dataAction: new TableActionClass(data),
    }
  },
}

function methods() {
  var context = {};
  context["getCsContList"] = getCsContList;  // get list
  context["getCsContItem"] = getCsContItem;  // get item
  context["deleteCsCont"] = deleteCsCont;  // delete item
  context["saveCsCont"] = saveCsCont;  // save item

  // 목록
  async function search() {
    let _params = this.data.params
    this.dataAction.execute("getCsContList", context, _params);
  }

  // 상세
  async function edit(_params) {
    _params = !_params ? this.data.row : _params
    await this.dataAction.execute("getCsContItem", context, _params);
  }

  // 삭제
  async function remove(_params) {
    _params = !_params ? this.data.row : _params
    await this.dataAction.execute("deleteCsCont", context, _params);
    this.search();
  }

  // 저장
  async function save() {
    const validForm = await this.$validator.validateAll('edit').then((result) => {
      return result;
    });
    if (validForm) {
      let _params = this.data.row
      await this.dataAction.execute("saveCsCont", context, _params);
      this.search();
    }
  }

  // 초기화
  async function reset() {
    this.dataAction.clear();
  }

  async function upload(_files) {
    console.log('Page upload called', _files)
  }

  /*async function upload(event){
    this.loading = true;
    var formData = new FormData();
    formData.append("mfile",event.target.files[0]);
    formData.append("newFileName","abcd");
    formData.append("floderDiv","BANNER"); /!* AwsS3Floder.java *!/
    let result = await uploadCsFile(formData);
    this.files.push(result.data)
    let length = this.files;

    //this.files.splice(length)
    this.loading = false;
    console.log('length;',length, 'this.files',this.files )
  }*/

  return {reset, search, edit, save, remove, upload}
}


</script>